import { useContext, useEffect } from "react";
import { GraphContext } from "./data";
import Slider from "@mui/material/Slider";
import React from "react";

export const RangePanel = () => {
  const { rangeList, sharedData, setSharedData } = useContext(GraphContext);
  // const [min, setMin] = React.useState<number>(0);
  // const [max, setMax] = React.useState<number>(100);
  // const [step, setStep] = React.useState<number>(1);

  // useEffect(() => {
  //   console.log("rangeList:", rangeList);
  //   if (rangeList && rangeList.length > 0) {
  //     setMin(rangeList[0].min);
  //     setMax(rangeList[0].max);
  //     setStep((rangeList[0].min - rangeList[0].max) / 100);
  //   }
  // }, [rangeList]);

  // console.log("cluster props:", clusterData);
  if (!rangeList || rangeList.length < 1) {
    return null;
  }

  const rangeIndex = 0;
  const min = rangeList[rangeIndex].min;
  const max = rangeList[rangeIndex].max;
  const step = (rangeList[rangeIndex].min - rangeList[rangeIndex].max) / 100;
  const marks = [
    {
      value: min,
      label: min,
    },
    {
      value: max,
      label: max,
    },
  ];
  let timeout: any;
  const onValueChanged = (e: Event, newValue: number | number[]) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      console.log("range:", newValue);
      if (typeof newValue === "object") {
        setSharedData({
          source: "",
          subType: "",
          rangeMin: newValue[0],
          rangeMax: newValue[1],
          rangeField: rangeList[rangeIndex].field,
        });
      }
    }, 500);
  };
  const onCheck = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSharedData({
      source: "",
      subType: "",
      rangeMin: sharedData.rangeMin || min,
      rangeMax: sharedData.rangeMax || max,
      rangeField: e.target.checked ? rangeList[rangeIndex].field : '',
    });
  }
  return (
    <div className={"range-panel"}>
      <div className="title">
        <label htmlFor="check1">{rangeList[0].field}</label>
        <input
          type="checkbox"
          id="check1"
          checked={!!sharedData.rangeField}
          onChange={onCheck}
        />
        {/* {rangeList.map((i) => (
          <select key={i.field}>
            <option>{i.field}</option>
          </select>
        ))} */}
      </div>
      <div className="slider">
        <Slider
          track="inverted"
          aria-labelledby="track-inverted-slider"
          // getAriaValueText={'value'}
          valueLabelDisplay="auto"
          defaultValue={[min, max]}
          marks={marks}
          min={min}
          max={max}
          step={step}
          onChange={onValueChanged}
        />
      </div>
    </div>
  );
};
